import React, { useCallback } from 'react';
import { useDrag } from 'react-dnd';
import { useDocumentContext } from '../../context/complexDocumentContext';

const DynamicContentCell = ({ editable, itemUUID, pageId, customStyle, children, isInteractiveDesign }) => {

  const customSelector = useCallback(store => store[itemUUID], []);
  const [item] = useDocumentContext(customSelector, `Block-${itemUUID}`);

  const [{ isDragging }, drag] = useDrag({
    canDrag: () => isInteractiveDesign ? item.isEditable : editable,
    item: { type: item.type, element: item },
    begin: () => ({
      type: item.type,
      element: {
        elementDetails: item
      },
      pageId
    }),
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return (
    <div key={item.uuid} className={`moveable ${isDragging ? 'dragging' : ''}`} ref={drag} style={customStyle}>
      {children}
    </div>
  )
}

export default DynamicContentCell;